// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#\\@vmos-vmos-flyout-app__sFPoT button{cursor:pointer}.\\@vmos-vmos-flyout-base-icon___98CW{height:24px;display:flex;flex-direction:column;justify-content:center}.\\@vmos-vmos-flyout-base-icon--amg__aYUz5,.\\@vmos-vmos-flyout-base-icon--maybach__YQB94{height:10px}.\\@vmos-vmos-flyout-base-icon--alternative-fuel__N9PKq{height:24px;margin-left:-5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": "@vmos-vmos-flyout-app__sFPoT",
	"baseIcon": "@vmos-vmos-flyout-base-icon___98CW",
	"baseIconAmg": "@vmos-vmos-flyout-base-icon--amg__aYUz5",
	"baseIconMaybach": "@vmos-vmos-flyout-base-icon--maybach__YQB94",
	"baseIconAlternativeFuel": "@vmos-vmos-flyout-base-icon--alternative-fuel__N9PKq"
};
export default ___CSS_LOADER_EXPORT___;
